import React from 'react';
import { Link } from "../../components/elements/Link";
import { Paragraph } from "../../components/typography/Paragraph";
import { PRIVACY_POLICY } from "../default-strings/constants";
export var getPrivacyConsentLabel = function getPrivacyConsentLabel(privacyConsentLabelText, privacyConsentLabelLinkUrl) {
  var privacyConsentLabelLinkText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PRIVACY_POLICY;
  return React.createElement("label", {
    className: "privacy-consent-label"
  }, React.createElement(Paragraph, null, privacyConsentLabelText), privacyConsentLabelLinkUrl && React.createElement(Link, {
    href: privacyConsentLabelLinkUrl,
    willOpenInNewTab: true
  }, privacyConsentLabelLinkText));
};